module.exports = __webpack_public_path__ + "img/mont-chamber.da8bed11.jpg";